export const DisplayFormats = {
    Integer: /^[0-9\-]$/,
    Decimal: /^[0-9.\-]$/,
    Custom: (regex: RegExp) => regex
};
